<!-- asOfDate row-->
<div class="row">
	<div class="col-4">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
	</div>
</div>
<div class="table padding-vertical-25 padding-horizontal-10">
	<!-- Header -->
	<div class="row header padding-vertical-5">
		<div class="col-10">
			<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
	</div>

	<!-- Rows -->
	<div class="row margin-top-30" *ngFor="let row of GHOST_ROWS">
		<div class="col-10">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2 text-align-right">
			<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
	</div>
</div>
